export const API_URL = `${window.location.origin}`;

export const ASSETS_URL = `${window.location.origin}`;
